import { useEffect, useRef } from 'react';
import { getWorkbookSheets, selectionToRange } from '@/services/univerjs/utils';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
import { getActiveWorksheetIndex } from '@/services/univerjs';
import { delayInitialUniverCmd } from './utils'; // const PREFIX = 'components: Spreadsheet: useUniverObservers:';

export default function useUniverObservers(univerAPI, settings) {
  const {
    isEditing,

    /*targetSheet,*/
    targetSelection,
    onClipboardError
  } = settings;
  const isInitializedRef = useRef(false); // Set editable / uneditable

  useEffect(() => {
    if (!univerAPI || isEditing === undefined) return;
    setTimeout(() => {// Fix for issue where cells are still editable
      // Currently nothing is working
      // OPTION #1: https://univer.ai/guides/sheet/features/permission
      // univerAPI?.getActiveWorkbook()?.setEditable(isEditing);
      // OPTION #2: Custom Plugin
      // TODO: fix sheet cells still editable #552
      //       waiting for new release (current v0.1.11)
      // univerAPI.executeCommand(
      //   `custom.operation.set.${isEditing ? 'editable' : 'uneditable'}`
      // );
    }, 10);
  }, [univerAPI, isEditing]); // Set the active sheet when it is updated externally

  useEffect(() => {
    if (!univerAPI || !targetSelection) {
      return;
    }

    let sheetChangeCmd = Promise.resolve();
    const targetSheetIndex = spreadsheetCore.getSpreadsheetIndex(targetSelection);
    let activeWorkSheet;

    try {
      // @ts-ignore
      const activeWorkbook = univerAPI.getActiveWorkbook();
      if (!activeWorkbook) return;
      const workbookId = activeWorkbook.getId();
      const activeSheetIndex = getActiveWorksheetIndex(activeWorkbook);
      const sheets = getWorkbookSheets(activeWorkbook);
      activeWorkSheet = sheets[targetSheetIndex]; // Get pre-generated sheets

      if (targetSheetIndex !== activeSheetIndex) {
        const activeSheetId = (activeWorkSheet || {
          getSheetId: () => ''
        }).getSheetId();

        if (workbookId && activeSheetId) {
          sheetChangeCmd = univerAPI.executeCommand('sheet.command.set-worksheet-activate', {
            unitId: workbookId,
            subUnitId: activeSheetId
          });
        }
      } // Determine if provided selections
      // does not target an entire row/column


      const [first, last] = spreadsheetCore.cellReferencesToAddress(targetSelection);
      const isNonRowOrColumnSelection = isFinite(first.row + first.col + (last || first).row + (last || first).col); // Scroll selected cell/range into view
      // after any necessary sheet change completed
      // NOTE: Not consistently accurate
      // NOTE: ignore row/column selections as this
      //       will automatically modify them

      if (activeWorkSheet && isNonRowOrColumnSelection) {
        const [firstCellRef] = spreadsheetCore.splitCellRefs(targetSelection);
        const scrollRange = selectionToRange(firstCellRef); // Scroll to beginning of selection

        const selectionRange = selectionToRange(targetSelection);
        sheetChangeCmd.finally(() => {
          delayInitialUniverCmd(isInitializedRef.current, () => {
            requestAnimationFrame(() => univerAPI.executeCommand('sheet.command.scroll-to-cell', {
              range: scrollRange
            }));
            univerAPI.executeCommand('sheet.operation.set-selections', {
              selections: [{
                range: selectionRange
              }],
              unitId: workbookId,
              type: 2
            });
            isInitializedRef.current = true;
          });
        });
      }
    } catch (err) {// TODO add user/system error notification
    } // NOTE: should not update when active sheet changes
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [univerAPI, targetSelection]); // Catch unhandled clipboard promise rejections

  useEffect(() => {
    function handler(event) {
      if (typeof onClipboardError !== 'function') return;

      if (event.reason && event.reason.name === 'NotAllowedError' && event.reason.message.includes('Clipboard')) {
        // Handle clipboard error
        event.preventDefault(); // Optionally prevent default error handling

        onClipboardError(event.reason);
      }
    }

    window.addEventListener('unhandledrejection', handler);
    return () => {
      window.removeEventListener('unhandledrejection', handler);
    };
  }, [onClipboardError]);
}